import React from 'react';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import GoogleClassroomShareModal from '../GoogleClassroomShareModal/index';
import MultiDropDown from '../MultiDropDown';
import Modal from '../Modal/index';
import CustomToast from '../Toast';
import HesSpinner from '../loadingOverlay/hesSpinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTrash,
  faVolumeHigh,
  faCopy,
  faUsers,
  faEdit
} from '@fortawesome/free-solid-svg-icons';
import {
  faCalculator,
  faVolumeSlash,
  faUpload,
  faCameraSlash,
  faClock,
  faLanguage,
  faShuffle,
  faEye,
  faEyeSlash,
  faCalendarDays,
  faEraser,
  faLockA,
  faTimer
} from '@fortawesome/pro-solid-svg-icons';
import {
  useLazyGetAssignmentLinksQuery,
  useDeleteAssignmentLinksMutation,
  useSaveAssignmentLinkNoteMutation
} from '../../features/authentication/authApiSlice';
import { OverlayTrigger, Tooltip, Col, Row } from 'react-bootstrap';
import StudentClipboardImg from '../../assets/images/studentClipboard.png';
import assignedVia_1 from '../..//assets/images/assignedVia_1.png';
import assignedVia_2 from '../../assets/images/assignedVia_2.png';
import assignedVia_3 from '../../assets/images/assignedVia_3.png';
import assignedVia_4 from '../../assets/images/assignedVia_4.png';
import { useGetAllAssignedViaMutation } from '../../features/authentication/authApiSlice';
import ConfirmationModal from '../ConfirmationPopUp';
import { useLazyGetAssessmentLinksQuery } from '../../features/authentication/assessmentApiSlice';
import moment from 'moment';
import { DateFormatter } from '../../utils/DateFormatter';

function Index({
  showAssignmentLinksModal,
  setShowAssignmentLinksModal,
  showAssignedViaFilter,
  assignmentIdFilter,
  isAssessment = false
}) {
  const [triggerAssignments] = useLazyGetAssignmentLinksQuery();
  const [triggerAssessments] = useLazyGetAssessmentLinksQuery();
  const [assignmentLinks, setAssignmentLinks] = useState([]);
  const [deleteAssignmentLinkCall] = useDeleteAssignmentLinksMutation();
  const [saveAssignmentLinkNote] = useSaveAssignmentLinkNoteMutation();
  const [getAllAssignedVia] = useGetAllAssignedViaMutation();
  const [assignedViaList, setAssignedViaList] = useState([]);
  const [selectedAssignViaList, setSelectedAssignViaList] = useState([]);
  const [showShareToGoogleClassroomModal, setShowShareToGoogleClassroomModal] = useState(false);
  const [shareToGoogleGuid, setShareToGoogleGuid] = useState(null);
  const [shareToGoogleAssignmentName, setShareToGoogleAssignmentName] = useState(null);
  const [addNoteModel, setAddNoteModel] = useState(false);
  const [contentNote, setContentNote] = useState('');
  const [noteDescription, setNoteDescription] = useState('');
  const [urlGuid, setUrlGuid] = useState('');
  const [confirmModel, setConfirmModel] = useState(false);
  const [deleteAssignment, setDeleteAssignment] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  var dateTimeOptions = {
    month: '2-digit',
    day: '2-digit',
    year: '2-digit',
    hour: 'numeric',
    minute: '2-digit'
  };

  async function refetchLinks() {
    setIsLoading(true);
    setError(null);

    try {
      let response;
      if (isAssessment) {
        response = await triggerAssessments().unwrap();
      } else {
        loadAssignedVia();
        response = await triggerAssignments().unwrap();
      }
      setAssignmentLinks(response);
    } catch (error) {
      setError(error);
    }
    setIsLoading(false);
  }

  useEffect(() => {
    if (showAssignmentLinksModal) {
      refetchLinks();
    }
  }, [showAssignmentLinksModal, isAssessment]);

  async function loadAssignedVia() {
    try {
      const response = await getAllAssignedVia();
      setAssignedViaList(
        response.data.map((item) => {
          return { name: item.name, id: item.id, description: item.name, isChecked: true };
        })
      );
      setSelectedAssignViaList(response.data.map((item) => item.id));
    } catch (error) {
      console.error('Failed to load Assigned Via', error);
    }
  }

  function copyLinkToClipboard(fullUrl) {
    navigator.clipboard.writeText(fullUrl);
    CustomToast('Link copied', 'info');
  }

  const confirmDelete = (assignment) => {
    setDeleteAssignment(assignment);
    setConfirmModel(true);
  };

  async function deleteAssignmentLink(urlLink) {
    try {
      await deleteAssignmentLinkCall(urlLink.urlGuid).unwrap();
      await refetchLinks();
      CustomToast(`${isAssessment ? 'Assessment' : 'Assignment'} Link Deleted Successfully`, 'success');
    } catch {
      CustomToast(`Error! Failed to delete ${isAssessment ? 'assessment' : 'assignment'} link`, 'danger');
    }
    setConfirmModel(false);
  }

  const assignmentNoteDescription = (event) => {
    setContentNote(event.target.value);
    setNoteDescription(event.target.value);
  };

  const saveNote = async () => {
    const options = {
      note: noteDescription,
      urlGuid: urlGuid
    };
    const response = await saveAssignmentLinkNote(options).unwrap();
    if (response) {
      const updatedAssignmentLinks = assignmentLinks?.map((item) => {
        if (item.urlGuid === urlGuid) {
          return { ...item, note: noteDescription };
        }
        return item;
      });
      setAssignmentLinks(updatedAssignmentLinks);
      setAddNoteModel(false);
    }
  };

  function handleAssignedViaFilterChange(e) {
    const { key } = e;
    const selected = key !== '000' ? assignedViaList.find((v) => v.id == key) : assignedViaList;
    let tempValue = [];

    if (key === '000') {
      tempValue = assignedViaList.map((item) => ({
        ...item,
        isChecked: !assignedViaList.filter((item) => item?.isChecked !== true).length < 1
      }));
    } else {
      tempValue = assignedViaList.map((item) =>
        item.id == key ? { ...item, isChecked: !selected.isChecked } : item
      );
    }
    setAssignedViaList(tempValue);
    const ids = tempValue.filter((item) => item?.isChecked === true).map((itemId) => itemId.id);
    setSelectedAssignViaList(ids);
  }

  const handleShareToGoogleClassroom = (isLinkExpired, urlGuid, assignmentName) => {
    if(isLinkExpired) return;

    setShareToGoogleGuid(urlGuid);
    setShareToGoogleAssignmentName(assignmentName);
    setShowShareToGoogleClassroomModal(true);
  };

  const GenerateAssignmetModeIcons = (assignmentMode, index) => {
    let modeIcon = null;
    let optionIcon = null;

    switch (assignmentMode) {
    case 0:
    case 4:
    case 6:
      modeIcon = (
        <OverlayTrigger
          key={`assignmentMode-${index}`}
          placement="top"
          overlay={<Tooltip className="custom-tooltip">Mode: Open</Tooltip>}
        >
          <div className="assignmentOptions m-0" style={{ color: '#48E0B2', backgroundColor: '#E3FFF6' }}>
            Open
          </div>
        </OverlayTrigger>
      );
      break;

    case 2:
    case 7:
    case 8:
    case 9:
      modeIcon = (
        <OverlayTrigger
          key={`assignmentMode-${index}`}
          placement="top"
          overlay={<Tooltip className="custom-tooltip">Mode: Quiz</Tooltip>}
        >
          <div className="assignmentOptions m-0" style={{ color: '#A29BFE', backgroundColor: '#E9E9FD' }}>
            Quiz
          </div>
        </OverlayTrigger>
      );
      break;

    case 1:
      modeIcon = (
        <OverlayTrigger
          key={`assignmentMode-${index}`}
          placement="top"
          overlay={<Tooltip className="custom-tooltip">Mode: Locked</Tooltip>}
        >
          <div className="assignmentOptions m-0" style={{ color: '#F84646', backgroundColor: '#FFE3E3' }}>
            Locked
          </div>
        </OverlayTrigger>
      );
      break;

    case 3:
      modeIcon = (
        <OverlayTrigger
          key={`assignmentMode-${index}`}
          placement="top"
          overlay={<Tooltip className="custom-tooltip">Mode: Review</Tooltip>}
        >
          <div className="assignmentOptions m-0" style={{ color: '#FFA800', backgroundColor: '#FFF4E3' }}>
            Review
          </div>
        </OverlayTrigger>
      );
      break;

    case 5:
      modeIcon = (
        <OverlayTrigger
          key={`assignmentMode-${index}`}
          placement="top"
          overlay={<Tooltip className="custom-tooltip">Mode: Offline</Tooltip>}
        >
          <div className="assignmentOptions m-0" style={{ color: '#525252', backgroundColor: '#F0F2F8' }}>
            Offline
          </div>
        </OverlayTrigger>
      );
      break;

    case 11:
      modeIcon = (
        <OverlayTrigger
          key={`assignmentMode-${index}`}
          placement="top"
          overlay={<Tooltip className="custom-tooltip">Mode: GradeCam</Tooltip>}
        >
          <div className="assignmentOptions m-0" style={{ color: '#82A9E2', backgroundColor: '#E4EFFC' }}>
            GradeCam
          </div>
        </OverlayTrigger>
      );
      break;
    }

    switch (assignmentMode) {
    case 2:
      optionIcon = (
        <OverlayTrigger key={`opt-${index}`} placement="top"
          overlay={<Tooltip className="custom-tooltip">Show grade upon completion</Tooltip>}>
          <div className="assignmentOptions m-0" style={{ backgroundColor: '#E3FFF6' }}>
            <FontAwesomeIcon icon={faEye} color="#48E0B2" />
          </div>
        </OverlayTrigger>
      );
      break;

    case 6:
      optionIcon = (
        <OverlayTrigger key={`opt-${index}`} placement="top"
          overlay={<Tooltip className="custom-tooltip">Automatically lock questions</Tooltip>}>
          <div className="assignmentOptions m-0" style={{ backgroundColor: '#FFE3E3' }}>
            <FontAwesomeIcon icon={faLockA} color="#F84646" />
          </div>
        </OverlayTrigger>
      );
      break;

    case 8:
      optionIcon = (
        <OverlayTrigger key={`opt-${index}`} placement="top"
          overlay={<Tooltip className="custom-tooltip">Allow changes to answers</Tooltip>}>
          <div className="assignmentOptions m-0" style={{ backgroundColor: '#FFF2F7' }}>
            <FontAwesomeIcon icon={faEraser} color="#FD79A8" />
          </div>
        </OverlayTrigger>
      );
      break;

    case 9:
      optionIcon = (
        <OverlayTrigger key={`opt-${index}`} placement="top"
          overlay={<Tooltip className="custom-tooltip">Don&apos;t show grade upon completion</Tooltip>}>
          <div className="assignmentOptions m-0" style={{ backgroundColor: '#FFE3E3' }}>
            <FontAwesomeIcon icon={faEyeSlash} color="#F84646" />
          </div>
        </OverlayTrigger>
      );
      break;
    }

    return (<>{modeIcon}{optionIcon}</>);
  };

  return (
    <>
      <Modal
        contentWidth="1200px"
        detailHeight="600px"
        isOpen={showAssignmentLinksModal}
        titleName={`Your ${isAssessment ? 'Assessment' : 'Assignments'} Links`}
        onClose={() => setShowAssignmentLinksModal(false)}>
        <div className="public-assignments">
          <p className='mt-2 mb-3 cursor-none'>
            The following are {isAssessment ? ' Assessment ' : ' Assignments '} Links that you own. Click
            <button className="mx-2 shareToGoogleClassroomBtn">
              <FontAwesomeIcon icon={faUsers} />
            </button>
            icon to share to Google Classroom or click
            <button className="mx-2 assignmentlinkCopyBtn">
              <FontAwesomeIcon icon={faCopy} />
            </button>
            icon to copy the link to clipboard then paste where you need it.
          </p>
          {!isAssessment && showAssignedViaFilter && (
            <Row className="d-flex align-items-center col-6 align-items-baseline">
              <Col className='cursor-none'>Assignment Method</Col>
              <Col className="col-7 h-70">
                <MultiDropDown
                  value={assignedViaList}
                  setValue={setAssignedViaList}
                  dropdownId="assignedViaFilter"
                  handleChange={(e) => handleAssignedViaFilterChange(e)}
                  selectedId={selectedAssignViaList}
                  setSelectedId={setSelectedAssignViaList}
                  description={true}
                  selectAllText="All Assigned Via"
                />
              </Col>
            </Row>
          )}
          <div className='custom-table table-responsive'>
            <table className="table">
              <thead>
                <tr>
                  <th>{isAssessment ? 'Assessment' : 'Assignment'}</th>
                  <th>Date</th>
                  <th>Notes</th>
                  {!isAssessment && <th>Assigned Via</th>}
                  <th>Details</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {error && (
                  <tr>
                    <td colSpan="7" style={{ textAlign: 'center' }}>
                      <button
                        className='bg-body border-0 fs-5 text-danger'
                        onClick={refetchLinks}>
                        There was an error getting the data. Click to try again
                      </button>
                    </td>
                  </tr>
                )}
                {isLoading && (
                  <tr>
                    <td colSpan="7">
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ height: '40px' }}>
                        <HesSpinner />
                        <span className="ms-3">Loading results...</span>
                      </div>
                    </td>
                  </tr>
                )}

                {!isLoading && !error && assignmentLinks.length == 0 && (
                  <tr>
                    <td colSpan="7">
                      <div
                        className="d-flex align-items-end justify-content-center text-align-center"
                        style={{
                          backgroundImage: `url(${StudentClipboardImg})`,
                          backgroundRepeat: 'no-repeat',
                          height: '130px',
                          backgroundPositionX: 'center'
                        }}>
                        {assignmentIdFilter && assignmentIdFilter.length == 0 ? (
                          <span>You do not have any assignment links created</span>
                        ) : (
                          <span>
                            {`There are no ${isAssessment ? 'assessment' : 'assignment'} links for ${assignmentIdFilter && assignmentIdFilter.length === 1 ? 'this' : 'these'} ${isAssessment ? 'assessment' : 'assignment'}${assignmentIdFilter && assignmentIdFilter.length === 1 ? '' : 's'}`}
                          </span>
                        )}
                      </div>
                    </td>
                  </tr>
                )}

                {assignmentLinks.map((item, index) => {
                  if (!isAssessment && selectedAssignViaList.includes(item.assignedViaId) == false) return;
                  let assignedViaImage = null;
                  let tooltipContent = null;

                  switch (item.assignedViaId) {
                  case 1:
                    assignedViaImage = assignedVia_1;
                    tooltipContent = 'Castle';
                    break;
                  case 2:
                    assignedViaImage = assignedVia_2;
                    tooltipContent = 'Google Classroom';
                    break;
                  case 3:
                    assignedViaImage = assignedVia_3;
                    tooltipContent = 'Schoology';
                    break;
                  case 4:
                    assignedViaImage = assignedVia_4;
                    tooltipContent = 'Canvas';
                    break;
                  }
                  return (
                    <tr
                      key={`assignment-link-list-${item.urlGuid}`}
                      style={{ position: 'relative' }}>
                      <td>{item.assignmentName}</td>
                      <td>{DateFormatter.toLongDateTime2(item.dateTime)}</td>
                      <td>
                        <div className="d-flex action-btns align-items-center">
                          {item.note}
                          <OverlayTrigger
                            key="editToolTip"
                            placement="top"
                            overlay={<Tooltip className="custom-tooltip">Click to Edit</Tooltip>}>
                            <button
                              className="orange-edit"
                              onClick={() => {
                                setAddNoteModel(true),
                                setContentNote(item.note),
                                setUrlGuid(item.urlGuid);
                              }}>
                              {' '}
                              <FontAwesomeIcon icon={faEdit} />
                            </button>
                          </OverlayTrigger>
                        </div>
                      </td>
                      {!isAssessment &&
                        <td>
                          <OverlayTrigger
                            key="assignedVia"
                            placement="top"
                            overlay={<Tooltip className="custom-tooltip">{tooltipContent}</Tooltip>}>
                            <img
                              src={assignedViaImage}
                              className="img-fluid"
                              alt=""
                              data-tooltip-id={`icon-${index}`}
                            />
                          </OverlayTrigger>
                        </td>
                      }
                      <td>
                        <div className="d-flex flex-column action-btns gap-2">
                          <div className='d-flex flex-row align-items-center gap-2'>
                            {GenerateAssignmetModeIcons(item.assignmentMode, index)}
                            {item.startDate?.length > 0 && (
                              <OverlayTrigger
                                key={`assignmentTimedOut-${index}`}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-assignmentTimedOut-${index}`} className="custom-tooltip">
                                    From/To
                                    <br />
                                    {`${new Date(item.startDate).toLocaleString(
                                      'en-US',
                                      dateTimeOptions
                                    )} - ${new Date(item.endDate).toLocaleString(
                                      'en-US',
                                      dateTimeOptions
                                    )}`}
                                  </Tooltip>
                                }>
                                <div className="assignmentOptions m-0" style={{ backgroundColor: '#D9F6FF' }}>
                                  <FontAwesomeIcon icon={faCalendarDays} color="#09BCF3" />
                                </div>
                              </OverlayTrigger>
                            )}
                            {item.timeSpan != null && item.timeSpan.length > 0 && (
                              <OverlayTrigger
                                key={`timed-${index}`}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-timedOption-${index}`} className="custom-tooltip">
                                    {isAssessment? 'Assessment' : 'Assignment'} is timed:{' '}
                                    {`${moment.duration(item.timeSpan)?.hours() > 0 ? moment.duration(item.timeSpan)?.hours() + 'h' : ''} ${moment.duration(item.timeSpan)?.minutes()}m`}
                                  </Tooltip>
                                }>
                                <div className="assignmentOptions m-0 assignmentOptionsIcon">
                                  <FontAwesomeIcon color="#82A9E2" icon={faTimer} />
                                </div>
                              </OverlayTrigger>
                            )}
                            {item.randomize && 
                              <OverlayTrigger
                                key={`randomizedOption-${index}`}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-randomizedOption-${index}`} className="custom-tooltip">
                                    Questions are Randomized
                                  </Tooltip>
                                }>
                                <div className="assignmentOptions m-0" style={{ backgroundColor: '#FFF2F7' }}>
                                  <FontAwesomeIcon color="#FD79A8" icon={faShuffle} />
                                </div>
                              </OverlayTrigger>
                            }
                          </div>
                          <div className='d-flex flex-row align-items-center gap-2'>
                            {item.isCalculator && (
                              <>
                                {item.calculatorType === 1 && (
                                  <OverlayTrigger
                                    key={`calculatorOption-${index}`}
                                    placement="top"
                                    overlay={
                                      <Tooltip id={`tooltip-calculatorOption-${index}`} className="custom-tooltip">
                                        A 4 Fucntion Calculator is available on screen for this {isAssessment? 'assessment' : 'assignment'}
                                      </Tooltip>
                                    }>
                                    <div className="assignmentOptions m-0" style={{ backgroundColor: 'lightpink' }}>
                                      <FontAwesomeIcon color="red" icon={faCalculator} />
                                    </div>
                                  </OverlayTrigger>
                                )}
                                {item.calculatorType === 2 && (
                                  <OverlayTrigger
                                    key={`calculatorOption-${index}`}
                                    placement="top"
                                    overlay={
                                      <Tooltip id={`tooltip-calculatorOption-${index}`} className="custom-tooltip">
                                        A Scientific Calculator is available on screen for this {isAssessment? 'assessment' : 'assignment'}
                                      </Tooltip>
                                    }>
                                    <div className="assignmentOptions m-0" style={{ backgroundColor: '#E4EFFC' }}>
                                      <FontAwesomeIcon color="#82A9E2" icon={faCalculator} />
                                    </div>
                                  </OverlayTrigger>
                                )}
                              </>
                            )}
                            {typeof item.readSpeaker === 'boolean' && (
                              <OverlayTrigger
                                key={`textToSpeech-${index}`}
                                placement="top"
                                overlay={
                                  <Tooltip className="custom-tooltip">
                                  Text-to-Speech {item.readSpeaker ? ' Disabled' : ' Enabled'}
                                  </Tooltip>
                                }>
                                <div className={`assignmentOptions m-0 ${item.readSpeaker ? 'bg-lightred' : 'bg-lightgreen'}`}>
                                  <FontAwesomeIcon icon={item.readSpeaker ? faVolumeSlash : faVolumeHigh} className={item.readSpeaker ? 'danger-icon-btn' : 'success-icon-btn'} />
                                </div>
                              </OverlayTrigger>
                            )}
                            {item.timePeriod > 0 && (
                              <OverlayTrigger
                                key={`timeOnTaskOption-${index}`}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-timeOnTaskOption-${index}`} className="custom-tooltip">
                                    The amount of time the student takes answering questions will be tracked
                                    <br />
                                    {`Maximum Time Per Question: ${item.timePeriod}`}
                                  </Tooltip>
                                }>
                                <div className="assignmentOptions m-0" style={{ backgroundColor: '#D9F6FF' }}>
                                  <FontAwesomeIcon icon={faClock} color="#09BCF3" />
                                </div>
                              </OverlayTrigger>
                            )}
                            {item.photoMathBlock && (
                              <OverlayTrigger
                                key={`photomathBlockerOption-${index}`}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-photomathBlockerOption-${index}`} className="custom-tooltip">
                                    Photomath Blocker Enabled
                                  </Tooltip>
                                }>
                                <div className="assignmentOptions m-0" style={{ backgroundColor: '#FFE3E3' }}>
                                  <FontAwesomeIcon icon={faCameraSlash} color="#F84646" />
                                </div>
                              </OverlayTrigger>
                            )}
                            {item.allowLanguageChange && (
                              <OverlayTrigger
                                key={`languageChangeOption-${index}`}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-languageChangeOption-${index}`} className="custom-tooltip">
                                    The student will be allowed to change the display language while taking this {isAssessment? 'assessment' : 'assignment'}
                                  </Tooltip>
                                }>
                                <div className="assignmentOptions m-0" style={{ backgroundColor: '#E3FFF6' }}>
                                  <FontAwesomeIcon icon={faLanguage} color="#48E0B2" />
                                </div>
                              </OverlayTrigger>
                            )}
                            {item.studentFileUpload && (
                              <OverlayTrigger
                                key={`studentFileUploadOption-${index}`}
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-studentFileUploadOption-${index}`} className="custom-tooltip">
                                    Student is allowed to upload files
                                  </Tooltip>
                                }>
                                <div className="assignmentOptions m-0" style={{ backgroundColor: '#E4EFFC' }}>
                                  <FontAwesomeIcon icon={faUpload} color="#82A9E2" />
                                </div>
                              </OverlayTrigger>
                            )}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="action-btns d-flex justify-content-end gap-2">
                          <OverlayTrigger
                            key="copyToClipboard"
                            placement="top"
                            overlay={
                              <Tooltip className="custom-tooltip">Copy to Clipboard</Tooltip>
                            }>
                            <button
                              className="retake"
                              onClick={() => copyLinkToClipboard(item.fullUrl)}>
                              {' '}
                              <FontAwesomeIcon icon={faCopy} />
                            </button>
                          </OverlayTrigger>
                          {(item.assignedViaId == 2 || isAssessment) &&
                          <OverlayTrigger
                            key="shareToClassroom"
                            placement="top"
                            overlay={
                              <Tooltip className="custom-tooltip">
                                {item.isLinkExpired ? 'Link Expired' : 'Share to Google Classroom'}
                              </Tooltip>
                            }>
                            <button
                              className={`pista-green ${item.isLinkExpired ? 'disabled' : ''}`}
                              onClick={() => {
                                handleShareToGoogleClassroom(item.isLinkExpired, item.fullUrl, item.assignmentName);
                              }}>
                              {' '}
                              <FontAwesomeIcon icon={faUsers} />
                            </button>
                          </OverlayTrigger>
                          }
                          <OverlayTrigger
                            key="deleteAssignment"
                            placement="top"
                            overlay={
                              <Tooltip className="custom-tooltip">Delete {isAssessment ? 'Assessment' : 'Assignment'} Link</Tooltip>
                            }>
                            <button
                              className="red"
                              onClick={() => {
                                confirmDelete(item);
                              }}>
                              {' '}
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </OverlayTrigger>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </Modal>
      <Modal
        contentWidth="600px"
        isOpen={addNoteModel}
        titleName={'Edit Notes'}
        onClose={() => setAddNoteModel(false)}>
        <textarea
          type="text"
          className="form-control textarea-lg"
          placeholder=" "
          name="noteDescription"
          id="noteDescription"
          value={contentNote}
          onChange={assignmentNoteDescription}
        />
        <div className="d-flex justify-content-end mt-3 gap-3 align-items-center">
          <button className="btn btn-castleGray print-btn" onClick={() => setAddNoteModel(false)}>
            Cancel
          </button>
          <button className="btn btn-castleRed print-btn" onClick={() => saveNote(false)}>
            Save
          </button>
        </div>
      </Modal>
      <ConfirmationModal
        isOpen={confirmModel}
        onClose={() => setConfirmModel(false)}
        onSave={() => deleteAssignmentLink(deleteAssignment)}
        contentWidth={'35%'}
        buttonPosition={'center'}
        content={`Are you sure that you want to delete the ${isAssessment ? 'assessment' : 'assignment'} link named "${deleteAssignment.assignmentName}"? All students will still see the link in their LMS but will not be able to start the ${isAssessment ? 'assessment' : 'assignment'} anymore. Please delete the ${isAssessment ? 'assessment' : 'assignment'} from your LMS if deleting here. This operation cannot be UNDONE!`}
        cancelButton={'No'}
        confirmButton={'Yes'}
      />
      <GoogleClassroomShareModal
        showShareToGoogleClassroomModal={showShareToGoogleClassroomModal}
        setShowShareToGoogleClassroomModal={setShowShareToGoogleClassroomModal}
        urlGuid={shareToGoogleGuid}
        assignmentName={shareToGoogleAssignmentName}
        isAssessment={isAssessment}
      />
    </>
  );
}

Index.propTypes = {
  showAssignmentLinksModal: PropTypes.bool,
  setShowAssignmentLinksModal: PropTypes.func,
  showAssignedViaFilter: PropTypes.bool,
  assignmentIdFilter: PropTypes.array,
  isAssessment: PropTypes.bool
};

export default Index;
